import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNaviconCreate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 8.5V27.5M8.5 18.0002H27.5",
		stroke: "#1D1D1D"
	})
});
export default SvgNaviconCreate;
